document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  const dialog = modal.querySelector('.product-media-modal__dialog');
  const swiperEl = modal.querySelector('.swiper');

  modal.addEventListener('click', (e) => {
    if (dialog && dialog.contains(e.target)) return;

    if (typeof modal.hide === 'function') modal.hide();
    else if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
  });

  if (swiperEl) {
    ['click','pointerdown','pointerup','mousedown','mouseup','touchstart','touchend']
      .forEach(evt => swiperEl.addEventListener(evt, e => e.stopPropagation()));
  }
});